import { controversyTimeline } from "@/mocks/home";

export default function ControversyReview() {
  return (
    <section id="controversy" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="max-w-xl">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Timeline</span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">争议回顾</h2>
          <p className="mt-2 text-sm text-foreground-600">
            把历次被反复提起的争议节点按年份顺下来，先弄明白每一次讨论是怎么起来的、又是怎么落下的。
          </p>
        </div>

        <ol className="mt-10 space-y-4">
          {controversyTimeline.map((item, index) => (
            <li
              key={item.year}
              className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 md:gap-6 md:p-6"
            >
              <div className="flex flex-col items-center">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-accent-500 font-heading text-base font-black text-background-50 dark:text-foreground-950">
                  {item.year}
                </span>
                {index !== controversyTimeline.length - 1 && (
                  <span className="mt-3 hidden w-px flex-1 bg-background-300 md:block"></span>
                )}
              </div>
              <div className="flex-1">
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-semibold text-secondary-900">
                    往期归档
                  </span>
                  <span className="rounded-full bg-background-200/80 px-2.5 py-0.5 text-[11px] font-medium text-foreground-600">
                    可对照时间线资料包
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}